import { useState } from 'react';
import quotes from 'quotesy';
import './PopupQuote.css';
import { Dialog } from 'primereact/dialog';
import { Icons } from '../Icons/Icons';
import { DailyEntryViewModel } from '../../../../ViewModel';




export function PopupQuote({ dailyEntry }: { dailyEntry: DailyEntryViewModel; }) {
    const [quote, setQuote] = useState<quotes.Quote>(dailyEntry.TypedData.quote ?? quotes.random());
    const [visible, setVisible] = useState(!dailyEntry.TypedData.viewSeenQuote);
    if (dailyEntry.TypedData.quote && dailyEntry.TypedData.quote !== quote)
        setQuote(dailyEntry.TypedData.quote);

    const quoteBlock = (
        <div className='gl-quote-block'>
            <div className='flex flex-row align-content-start'>
                <p className='gl-quote-quote'>“</p>
                <p className="Quote gl-quote-text gl-quote-typography" >

                    <span>{quote.text}</span>
                    <span className='Author gl-content-header-typography'>{`  - ${quote.author}`}</span>
                </p>
            </div>
            <div className='gl-quote-swoosh'>
                <svg xmlns="http://www.w3.org/2000/svg" width="316" height="81" viewBox="0 0 316 81" fill="none">
                    <path d="M15.7883 0.661621C6.45495 11.6616 -12.2117 39.6616 15.7883 63.6616C61.274 102.649 290.788 59 315.788 59" stroke="#669E72" />
                </svg>
            </div>
        </div>

    )

    return (
        <>
            <Dialog
                className='gl-quote-popup'
                visible={visible}
                dismissableMask
                resizable={false}
                maskClassName='gl-quote-mask  gl-tutorial-prevent-run'
                onHide={() => { if (!visible) return; setVisible(false); dailyEntry.TypedData.viewSeenQuote = true; }}
                // breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                content={({ hide }) => (
                    <>
                        <button
                            className='gl-close-button'
                            onClick={(e) => {
                                hide(e);
                                setVisible(false);
                                dailyEntry.TypedData.viewSeenQuote = true;
                            }}>
                            <Icons.CloseIcon />
                        </button>
                        <div className='gl-content-header-typography gl-header-content'>
                            <Icons.TitleIcon />
                            <p>Inspiration</p>
                        </div>
                        {quoteBlock}
                    </>
                )}
            />
            <div className='gl-quote-host'>
                {quoteBlock}
            </div>
        </>
    );
}